import axios from 'axios';
import ServerProperties from '../../config/server.js'

export default {
    ReadAsMaster: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.get(ServerProperties.ATM_CLOUD.API + params.data.query)
        .then(function (response) {
            params.onsuccess(params, response);
        })
        .catch(error => {
            if(error.response !== undefined) { //before != 
                params.onfailed(error.response.data.detail)
            }
            params.onfailed(error)
            // params.onfailed("Something Wrong")
        });
    },
    Update: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.put(ServerProperties.ATM_CLOUD.API + 'Tenant/Config/Update/',
            {
                GlobalMaxDay       : params.data.GlobalMaxDay,
                Urgency            : params.data.Urgency,
                StorageType        : params.data.StorageType,
                InactiveStatus     : params.data.InactiveStatus,
                MaintenanceType    : params.data.MaintenanceType,
                MaintenanceStatus  : params.data.MaintenanceStatus,
                StorageStatus      : params.data.StorageStatus,
                BusyStatus         : params.data.BusyStatus,
                BrokenStatus       : params.data.BrokenStatus,
                LostStatus         : params.data.LostStatus,
                AdminRole          : params.data.AdminRole,
                StorageRole        : params.data.StorageRole,
                DefaultCurrency    : params.data.DefaultCurrency,
                SingleCurrency     : params.data.SingleCurrency,
                CoverageCity       : params.data.CoverageCity,
                AuthorizationToken : params.data.UserReducer,
            }
        )
        .then(function (response) {
            params.onsuccess(params, response);
        })
        .catch(function (error) {
            if (error.response) {// The request was made and the server responded with a status code
                params.onfailed(error.response.data.detail)
            } else if (error.request) {// The request was made but no response was received
                params.onfailed(error.request)
            } else {// Error System
                params.onfailed("Something went wrong")
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/App/master/tenant_setting/model.js